import React from "react";
import { Dropdown, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Speaker } from "../../../../../types/scheduling/weekend";
import { ISODateString } from "../../../../../types/date";
import { NBSP } from "../../../../../helpers/util";
import { DisabledPublicTalkIndicator, outlineDisabled } from "../../wm_common";

interface TalkDropdownProps {
  speakers: Speaker[];
  selectedSpeaker?: number;
  selectedTalk?: number;
  setTalk: (talk: number) => void;
  date: ISODateString;
  disabled?: boolean;
  className?: string;
}

export const TalkDropdown: React.FC<TalkDropdownProps> = (props) => {
  const { t } = useTranslation();

  const speakerTalks = props.speakers
    .find((s) => s.id === props.selectedSpeaker)
    ?.public_talks.sort((a, b) => {
      if (a.number && b.number) {
        return a.number - b.number;
      }
      return 0;
    });

  return (
    <Form.Group className={props.className || "d-flex flex-column"}>
      <Form.Label className="fw-bolder text-muted mb-1">{t("schedules.general.talk")}</Form.Label>
      <Dropdown className="dropdown-bounded">
        <Dropdown.Toggle variant="secondary" disabled={!props.selectedSpeaker || !!props.disabled}>
          {props.selectedTalk || " "}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {(speakerTalks?.length ?? 0)
            ? speakerTalks
                ?.filter((pt) => pt.number !== props.selectedTalk)
                .map((pt) => {
                  const disabled = outlineDisabled(pt.number, props.date);
                  return (
                    <Dropdown.Item key={pt.number} onClick={() => props.setTalk(pt.number)}>
                      {pt.number || NBSP}
                      {!!pt.title && (
                        <div style={{ maxWidth: "30ch" }} className="text-muted text-truncate mb-0">
                          {pt.title}
                        </div>
                      )}
                      {!!disabled && <DisabledPublicTalkIndicator talkDate={disabled} />}
                    </Dropdown.Item>
                  );
                })
            : [
                <Dropdown.Item key="none" disabled={true}>
                  {t("general.none")}
                </Dropdown.Item>,
              ]}
        </Dropdown.Menu>
      </Dropdown>
    </Form.Group>
  );
};
